<template>
  <div class="app">
    <div class="app-content">
      <t-upper-nav />
      <main
        class="tw-overflow-y-aut tw-flex-1 tw-bg-light tw-p-4 max-lg:tw-ml-14"
      >
        <div class="tw-w-full">
          <t-page-header
            :product-links="productLinks"
            :user-links="userLinks"
            :data-test-id="'header-user-menu'"
          />
          <router-view />
        </div>
      </main>
      <cl-footer />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import TPageHeader from "@/components/TPageHeader";

import { usePrimaryNavItems } from "@/composables";
import TSideNav from "@/components/TSideNav";
import { NAV_ITEMS_MODE } from "@/constants";
import { TIER } from "@/constants";
import TLogo from "@/components/TLogo/TLogo.vue";
import TUpperNav from "@/components/TUpperNav/TUpperNav.vue";

export default {
  name: "ProfileLayout",
  components: {
    TPageHeader,
    TSideNav,
    TLogo,
    TUpperNav,
  },
  setup() {
    const { navItems } = usePrimaryNavItems();
    const profileNavItems = navItems.get(NAV_ITEMS_MODE.PROFILE);

    return {
      profileNavItems,
    };
  },
  data() {
    return {
      productLinks: [],
      userLinks: [],
      tier: TIER.profile,
    };
  },
  computed: {
    ...mapGetters("authentication", ["authUser"]),
    usePrimaryNavItems() {
      return this.separatedByGroup(this.profileNavItems);
    },
    user() {
      const email = this.authUser.email ?? null;
      const accountname = this.authUser.accountname ?? null;

      return {
        email,
        accountname,
      };
    },
  },
  methods: {
    separatedByGroup(mspArray) {
      const mspByGroup = {};
      const alpha = [];

      mspArray.forEach((item) => {
        if ("groupBy" in item) {
          if (mspByGroup[item.groupBy]) {
            mspByGroup[item.groupBy].push(item);
          } else {
            mspByGroup[item.groupBy] = [item];
          }
        } else {
          alpha.push(item);
        }
      });

      return mspByGroup;
    },
  },
  redirect() {
    this.$router.push("/profile");
  },
};
</script>
